import { useFormContext } from 'react-hook-form'
import { Form } from '..'
import { TextFieldInput } from '../../../../inputs/text-field-input'
import { useTranslation } from 'react-i18next'
import { SettingsSection } from '../../../../components/settings-section'
import { Stack } from '@mui/material'

export const Name = () => {
  const { control } = useFormContext<Form>()
  const { t } = useTranslation(['pos_profiles'])

  return (
    <SettingsSection>
      <Stack gap={2} sx={{ p: 2, pt: 1 }}>
        <TextFieldInput
          control={control}
          label={t('pos_profiles:name_section.name_title')}
          name="name"
          required
        />
      </Stack>
    </SettingsSection>
  )
}
